export default __webpack_public_path__ + "static/media/logo_sicredi.d1ba5001.png";